import { GetRulesMatchingTransactionsDto } from "../common/dto/transactionRule/get-rules-matching-transactions.dto";
import { GetRuleMatchingTransactionsResponseDto } from "../common/dto/transactionRule/get-rule-matching-transactions-response.dto";
import { backendClient, unwrapResponse } from "./backendClient";

export async function getMatchingTransactionsForRule(
    workspaceId: string,
    data: GetRulesMatchingTransactionsDto,
) {
    const dto = unwrapResponse(
        await backendClient.post<GetRuleMatchingTransactionsResponseDto>(
            `/rules/${workspaceId}/get-matching-transactions`,
            data,
        ),
    );

    return GetRuleMatchingTransactionsResponseDto.deserialize(dto);
}
